<script>
export default {
  data() {
    return {
      confirmLoading: false,
      selectedCraft: ''
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    versionList: {
      type: Array,
      default: () => []
    },
    productId: {
      type: String,
      default: ''
    },
    qcVersionDTO: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleOk() {
      const selectItem = this.versionList.find((res) => res.id === this.selectedCraft)
      const version = {
        craftId: selectItem.id,
        craftVersion: selectItem.version,
        productId: selectItem.productId
      }
      this.$emit('save', version)
    },
    handleCancel() {
      this.selectedCraft = ''
      this.$emit('close')
    },
    selectCraft(value) {
      this.selectedCraft = value
    }
  }
}
</script>

<template>
  <a-modal
    :title="$t('page_bom_realte_gybb')"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item :label="$t('page_extranet_Version1')">
        <a-select :placeholder="$t('please_select') + $t('page_extranet_Version1')" :value="selectedCraft" style="width: 100%" @change="selectCraft">
          <template v-for="(craft, index) in versionList">
            <a-select-option :value="craft.id" :key="index" class="craft-selection">
              {{ craft.version }}
            </a-select-option>
          </template>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<style lang="scss" scoped></style>
